import Image from 'next/image';
import { PAYMENT_METHODS } from './constants';
import { getImageBasePath } from 'utils/generics';
import * as Styles from './styles';

type PaymentMethodCardConfig = {
    icon: string;
    optionTitle: string;
    successText: string;
};

type PaymentMethodOptionCardProps = {
    method: string;
    config: PaymentMethodCardConfig;
    selectedPaymentMethod: string;
    isWalletDisabled: boolean;
    onSelectMethod: (method: string) => void;
};

function PaymentMethodOptionCard({
    method,
    config,
    selectedPaymentMethod,
    isWalletDisabled,
    onSelectMethod,
}: PaymentMethodOptionCardProps) {
    const isWalletMethod = method === PAYMENT_METHODS.WALLET;
    const isDisabled = isWalletMethod ? isWalletDisabled : false;

    const onCardClick = () => {
        if (isDisabled) return;
        onSelectMethod(method);
    };

    return (
        <Styles.OptionCard
            key={method}
            isSelected={selectedPaymentMethod === method}
            isDisabled={isDisabled}
            onClick={onCardClick}
        >
            <Styles.OptionTopRow>
                <Styles.Radio isSelected={selectedPaymentMethod === method} />
                <Styles.IconWrapper>
                    <Image
                        src={getImageBasePath(config.icon)}
                        alt=""
                        width={'22px'}
                        height={'22px'}
                    />
                </Styles.IconWrapper>
                <Styles.OptionTitle>{config.optionTitle}</Styles.OptionTitle>
            </Styles.OptionTopRow>
            {isWalletMethod && isWalletDisabled ? (
                <Styles.WarningTitleContainer>
                    <Image
                        src={getImageBasePath('/icons/errorRed.svg')}
                        alt=""
                        width={14}
                        height={14}
                    />
                    <Styles.WarningTitleText>
                        Insufficient balance for this order
                    </Styles.WarningTitleText>
                </Styles.WarningTitleContainer>
            ) : (
                <Styles.OptionSuccessText>
                    {config.successText}
                </Styles.OptionSuccessText>
            )}
        </Styles.OptionCard>
    );
}

export type { PaymentMethodCardConfig };
export default PaymentMethodOptionCard;
